import { LocationNumbersService } from "../../../services"

const fetchCompanyActiveNumbers = async function ({ commit }, payload) {
  commit('startLoading')
  try {
    const data = await LocationNumbersService.getCompanyActiveNumbers(payload)
    return data
  } catch (error) {
    throw error
  } finally {
    commit('stopLoading')
  }
}

export default fetchCompanyActiveNumbers